<template>
  <v-app>
    <confirm ref="confirm" />
    <v-snackbar
      id="snackbar_info"
      v-model="$store.state.snackbar.show"
      top
      right
      :color="$store.state.snackbar.color"
      :timeout="$store.state.snackbar.timeout"
    >
      {{ $store.state.snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          id="clear_notification"
          icon
          dark
          text
          v-bind="attrs"
          @click.native="hideSnackbar"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import confirm from "@/components/utils/confirm";

export default {
	name: "App",
	components: {
		confirm
	},
	mounted() {
		this.$root.$confirm = this.$refs.confirm;
	},
	methods:{
		hideSnackbar() {
			this.$store.commit("hideSnackbar");
		}
	}
};
</script>

